<template>
  <div class="order-container">
    <!-- 面包屑导航 -->
    <!-- <div class="breadcrumb-section">
      <div class="container">
        
      </div>
    </div> -->

    <!-- 订单内容区域 -->
    <div class="order-content container">
      <div class="breadcrumb-section">
        <el-breadcrumb separator="/">
          <el-breadcrumb-item :to="{ path: '/pc/mall' }">商城首页</el-breadcrumb-item>
          <el-breadcrumb-item>购物车</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <!-- <div class="order-tabs-section">
        <el-tabs v-model="activeTab" @tab-click="handleTabClick">
          <el-tab-pane label="全部订单(0)" name="all"></el-tab-pane>
          <el-tab-pane label="待付款(0)" name="pending_payment"></el-tab-pane>
          <el-tab-pane label="待发货(0)" name="pending_delivery"></el-tab-pane>
          <el-tab-pane label="待收货(0)" name="pending_receive"></el-tab-pane>
          <el-tab-pane label="待评价(0)" name="pending_review"></el-tab-pane>
          <el-tab-pane label="已完成(0)" name="completed"></el-tab-pane>
        </el-tabs>
      </div> -->

      <!-- 空状态展示 -->
      <div class="empty-state">
        <img :src="require('../../../assets/img/mall/no-cart.png')" alt="暂无购物车" class="empty-icon" />
        <p class="empty-text">购物车暂无商品~</p>
        <el-button type="text" size="small" @click="goToAllProducts">立即选购</el-button>
      </div>
    </div>

    <footer-layout></footer-layout>
  </div>
</template>

<script>
import FooterLayout from '@/components/pc/FooterLayout.vue'

export default {
  name: 'OrderPage',
  components: {
    FooterLayout
  },
  data() {
    return {
      activeTab: 'all',
      orders: [] // 订单列表数据
    }
  },
  methods: {
    handleTabClick(tab) {
      console.log('切换到:', tab.name)
      // 这里可以根据 tab.name 请求对应状态的订单数据
    },
    goToAllProducts() {
      this.$router.push('/pc/mall/allProducts')
    }
  }
}
</script>

<style lang="scss" scoped>
.order-container {
  min-height: 100vh;
  background: #f5f5f5;
  display: flex;
  flex-direction: column;
}

.container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
  display: flex;
  flex-direction: column;
  // justify-content: center;
  align-items: center;
}

.breadcrumb-section {
  min-width: 1000px;
  width: 100%;
  background: white;
  padding: 15px 0;
  border-bottom: 1px solid #e5e5e5;
  margin-bottom: 20px;

  ::v-deep .el-breadcrumb {
    font-size: 14px;
    line-height: 1;

    .el-breadcrumb__item {
      .el-breadcrumb__inner {
        color: #666;
        &:hover {
          color: #409eff;
        }
      }
      &:last-child {
        .el-breadcrumb__inner {
          color: #333;
        }
      }
    }
  }
}

.order-tabs-section {
  min-width: 1000px;
  background: white;
  padding: 15px 0;
  //   border-bottom: 1px solid #e5e5e5;
}

.order-content {
  flex: 1;
  background: white;
  margin: 20px auto;
  padding: 20px;
  border-radius: 8px;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.05);
  .el-tabs {
    min-width: 600px;
  }

  ::v-deep .el-tabs__nav-wrap::after {
    height: 1px;
    background-color: #e5e5e5;
  }

  ::v-deep .el-tabs__item {
    font-size: 15px;
    padding: 0 25px;
    height: 50px;
    line-height: 50px;

    &.is-active {
      color: #409eff;
      font-weight: bold;
    }

    &:hover {
      color: #409eff;
    }
  }

  .empty-state {
    padding: 60px 0;
    text-align: center;

    .empty-icon {
      width: 250px;
      height: 250px;
      margin-bottom: 20px;
    }

    .empty-text {
      color: #999;
      font-size: 14px;
      margin: 0;
    }
  }
}
</style>
